  export enum Role {
    Loadder = '-uL',
    Admin = '-uA',
    AdminDB = '-uADB',
    Downloader = '-uD',
  }